







import AnalyzeCustomServices, { DataItem, IndicatorInfo } from '@/services/analyzeCustom';
import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import EFunnel from './e-funnel.vue';
import ELine from './e-line.vue';
import EWall from './e-wall.vue';
@Component({
  components: { EFunnel, ELine, EWall }
})
export default class CustomFunnelView extends Vue {
  @Prop() title!: string;
  @Prop() info!: IndicatorInfo;
  @Prop() type!: number;
  @Prop() reload!: number;

  loading: boolean = false;
  columns: any[] = [];
  dataSource: any[] = [];
  groupByField: string = '';
  groupByFieldList: any[] = [];
  dimFieldCodes: string = '';
  dimFieldCodesList: any[] = [];

  created() {
    this.onVisibleChange();
  }

  list: any[] = [];
  customSrv = new AnalyzeCustomServices();
  @Watch('reload')
  async onVisibleChange() {
    let res = await this.customSrv.funnelPreview({ ...this.info, boardTool: this.type || 0, dataDate: this.info.dataDate || this.info.startTime });
    if (this.type < 3) {
      let list = res.result;
      if (this.type === 0) {
        let cacheList: any = [];
        this.info.indicatorInfoList.forEach((v: any) => {
          let item = list.find((r: any) => r.indCode === v.indCode);
          item && cacheList.push(item);
        });
        list = cacheList;
      }
      this.list = list.map((v: any) => ({ ...v, label: v.indName, value: v.sum }));
    } else {
      this.list = res.result;
    }
  }
}
